<div class="page-content">
    <div class="container-fluid">
        <app-quote-summary [showPayNow]=true [selectedQuote]="submittedQuote" [carDetails]="carDetails"
            [isPaymentShowForTpl]=false [isPaymentShowForComprehensive]=true [isSubmitted]=true
            [rateCardSelections]="selectedQuoteDetails" [isPaymentDone]=false [uploadedimages]="uploadedImageCounter"
            [isQuoteSummary]=false></app-quote-summary>
    </div>
    <!-- container-fluid -->
</div>
<!-- End Page-content -->